import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

// So that we can navigate to the same route without errors
// Should we be doing this? Maybe not.
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(() => {});
};

import AuthRoutes from "../routes/auth";
import DashboardRoutes from "../routes/dashboard";
import NotificationRoutes from "../routes/notification";
import Home from "../components/Home";

import AdminRoutes from "../routes/admin";
import AuthorRoutes from "../routes/author";
import ReviewRoutes from "../routes/review";
import EditorialRoutes from "../routes/editorial";
import PublisherRoutes from "../routes/publisher";
import SettingsRoutes from "../routes/settings";
import UserAccountRoutes from "../routes/account";

const router = new VueRouter({
  mode: "history",
  // mode: "hash",
  routes: [
    ...AdminRoutes,
    ...AuthRoutes,
    ...DashboardRoutes,
    ...NotificationRoutes,
    ...AuthorRoutes,
    ...EditorialRoutes,
    ...ReviewRoutes,
    ...PublisherRoutes,
    ...SettingsRoutes,
    ...UserAccountRoutes,
    {
      path: "/",
      name: "home",
      component: Home,
      // redirect: "/dashboard",
      redirect: "/manuscripts/start",
      meta: {
        requiresVisitor: true,
        description: "Home",
      },
    },
    {
      path: "*",
      redirect: "/",
    },
  ],
});

router.beforeEach((to, from, next) => {
  // if (to.matched.some((record) => record.meta.requiresAdmin)) {
  //   if (!localStorage.getItem("jmesrAuth")) {
  //     next({
  //       path: "/login",
  //       query: { redirect: to.fullPath },
  //     });
  //   } else {
  //     const { type } = JSON.parse(localStorage.getItem("jmesrUser"));
  //     if (type == "Administrator" || type == "Root") {
  //       next();
  //     } else if (type == "Examiner") {
  //       next({
  //         path: "questions",
  //       });
  //     } else {
  //       next({
  //         path: "/my-applications",
  //       });
  //     }
  //   }
  // } else {
  //   next();
  // }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!localStorage.getItem("jmesrAuth")) {
      next({
        path: "/login",
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next();
  }

  // if (to.matched.some((record) => record.meta.requiresTeacherOrMentor)) {
  //   const { type } = JSON.parse(localStorage.getItem("jmesrUser"));
  //   if (type == "Teacher" || type == "Mentor") {
  //     next();
  //   } else {
  //     next({
  //       path: "/my-applications",
  //     });
  //   }
  // } else {
  //   next();
  // }

  if (to.matched.some((record) => record.meta.requiresVisitor)) {
    if (localStorage.getItem("jmesrAuth")) {
      next({
        path: "/",
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
